export default __webpack_public_path__ + "static/media/logo.2a5052b7.PNG";